import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ReactNode} from "react";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";

interface InitialStateInterface {
    filters: FilterForMenu[],
    isExist: boolean,
    isVisible: boolean,
    key: string,
    [TableFilterKey.USER_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.NOMENCLATURE_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER]: FilterForMenu[],
    [TableFilterKey.INDIVIDUALS_GUIDE_FILTER]: FilterForMenu[],

    [TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.TECHNOLOGICAL_OPERATION_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.PRODUCTION_ORDER_JOURNAL_FILTER]: FilterForMenu[],
    [TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER]: FilterForMenu[],
    [TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER]: FilterForMenu[],
    [TableFilterKey.MEASUREMENT_UNIT_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER]: FilterForMenu[],
    [TableFilterKey.LOGS_FILTER]: FilterForMenu[],
}

export interface FilterForMenu{
    filterName: string,
    filter: ReactNode
}
interface AddFiltersToMenu {
    key: TableFilterKey;
    value: FilterForMenu[],
}

const initialState: InitialStateInterface = {
    filters: [],
    isExist: false,
    isVisible: false,
    key: "-",
    [TableFilterKey.USER_GUIDE_FILTER]: [],
    [TableFilterKey.NOMENCLATURE_GUIDE_FILTER]: [],
    [TableFilterKey.PRODUCTION_ORDER_EXECUTION_JOURNAL_FILTER]: [],
    [TableFilterKey.INDIVIDUALS_GUIDE_FILTER]: [],

    [TableFilterKey.ADMINISTRATIVE_ROLE_GUIDE_FILTER]: [],
    [TableFilterKey.TECHNOLOGICAL_PROCESS_CHART_GUIDE_FILTER]: [],
    [TableFilterKey.PRODUCTION_STAGE_GUIDE_FILTER]: [],
    [TableFilterKey.TECHNOLOGICAL_OPERATION_GUIDE_FILTER]: [],
    [TableFilterKey.ADMINISTRATIVE_AND_FUNCTIONAL_ZONE_GUIDE_FILTER]: [],
    [TableFilterKey.PRODUCTION_ORDER_JOURNAL_FILTER]: [],
    [TableFilterKey.PRODUCTION_ORDER_ARCHIVE_FILTER]: [],
    [TableFilterKey.PRODUCTION_ORDER_ANALYSIS_BY_TIME_FILTER]: [],
    [TableFilterKey.MEASUREMENT_UNIT_GUIDE_FILTER]: [],
    [TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER]: [],
    [TableFilterKey.LOGS_FILTER]: [],
}
export const filterNodesSlice = createSlice({
    name: "filters-for-menu-filters",
    initialState,
    reducers: {
        addFiltersToMenu: (state, action : PayloadAction<AddFiltersToMenu>) => {
            if (action.payload.key) {
                state[action.payload.key] = action.payload.value
            }
        },
        oldAddToMenuFilters: (state, action: PayloadAction<{ filterName: string, filter: ReactNode }[]>) => {
            state.filters = action.payload
        },
        changeMenuVisibility: (state, action: PayloadAction<boolean | undefined>) => {
            if (action.payload !== undefined) {
                state.isVisible = action.payload
            } else {
                state.isVisible = !state.isVisible
            }
        },
        changeMenuExistence: (state, action: PayloadAction<boolean>) => {
            state.isExist = action.payload
        },
        setKey: (state, action: PayloadAction<string>) => {
            state.key = action.payload
        }
    }
})

export const filterNodesActions = filterNodesSlice.actions
export const filterNodesReducer = filterNodesSlice.reducer